import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const githubMarketplacePlugin = createPlugin({
  id: 'github-marketplace',
  routes: {
    root: rootRouteRef,
  },
});

export const GithubMarketplacePage = githubMarketplacePlugin.provide(
  createRoutableExtension({
    name: 'GithubMarketplacePage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
